import Auth from '@/services/v1/auth'

const getters = {
  isAuthenticated: state => !!state.token && !Auth.isTokenExpired(state.token)
}

export default getters
